import { useInView } from "../../hooks/useInView";

export function AnimatedText({ text, className = "", tag: Tag = "p", delay = 0 }) {
  const [ref, inView] = useInView(0.1);
  const words = text.split(" ");
  return (
    <Tag ref={ref} className={className} aria-label={text}>
      {words.map((word, i) => (
        <span key={i} className="inline-block overflow-hidden" style={{ marginRight: "0.28em" }}>
          <span style={{ display: "inline-block", transform: inView ? "translateY(0)" : "translateY(110%)", opacity: inView ? 1 : 0, transition: `transform 0.5s cubic-bezier(0.22,1,0.36,1) ${delay + i * 55}ms, opacity 0.4s ease ${delay + i * 55}ms` }}>
            {word}
          </span>
        </span>
      ))}
    </Tag>
  );
}
